import { ICreateAlvenariaEstruturalServicosUseCase } from "../../../presentation/useCases/create/create_alvenaria_estrutural_servicos_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";


export class CreateAlvenariaEstruturalServicosUseCase implements ICreateAlvenariaEstruturalServicosUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async createAlvenariaEstrutural(IdObra: number,
    TipoBloco: string,
    Dimensao: string,
    Fornecedor: string,
    LocalAplicacao: string,
    QtdeRecibida: string,
    NrAmostras: string,
    NroNotaFiscal: string,
    NomeLaboratorio: string,
    EspecificacaoArgamassa: string,
    EnsaiosSolicitados: string,
    DataRecebimento: Date | null,
    DataEnvio: Date | null,
    ResponsavelCadastrado: boolean,
    DescResponsavel: string,
    IdFuncionario: number | null,
    Observacao: string,
    Ensaio1: string,
    Ensaio2: string,
    NroAmostras1: string,
    NroAmostras2: string,
    RbIdade1: string,
    RbIdade2: string,
    RbIdade3: string,
    RbResultado1: string,
    RbResultado2: string,
    RbResultado3: string,
    RaIdade1: string,
    RaIdade2: string,
    RaIdade3: string,
    RaResultado1: string,
    RaResultado2: string,
    RaResultado3: string,
    Aprovado: boolean,
    Arquivo1: File | null,
    Arquivo2: File | null,
    NrCorpoProva: string | null,
    ResistenciaSolicitada: string | null,
  ): Promise<void> {
    await this.repository.createAlvenariaEstrutural(IdObra, TipoBloco, Dimensao, Fornecedor, LocalAplicacao, QtdeRecibida, NrAmostras,
      NroNotaFiscal, NomeLaboratorio, EspecificacaoArgamassa, EnsaiosSolicitados, DataRecebimento, DataEnvio, ResponsavelCadastrado,
      DescResponsavel, IdFuncionario, Observacao, Ensaio1, Ensaio2, NroAmostras1, NroAmostras2, RbIdade1, RbIdade2, RbIdade3, RbResultado1, RbResultado2,
      RbResultado3, RaIdade1, RaIdade2, RaIdade3, RaResultado1, RaResultado2, RaResultado3, Aprovado, Arquivo1, Arquivo2, NrCorpoProva, ResistenciaSolicitada)
  }
}
